import { LeasePermissions as LeaseActions } from '@guiker/base-entity'

export { LeaseActions }
